import BaseLayout, {
  BasicProps as BaseLayoutProps,
} from 'antd/lib/layout/layout'

export interface LayoutProps extends BaseLayoutProps {}

export const Layout = (props: LayoutProps): JSX.Element => (
  <>
    <BaseLayout {...props} />
  </>
)
